export const LogoMark = ({ className = "h-10 w-auto" }) => (
  <img src="/logo.png" alt="Logo studio medico" className={`${className} object-contain`} data-testid="logo-mark" />
);

export default LogoMark;
